// Invoice PDF download — calls server-side Puppeteer endpoint

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export async function downloadInvoicePdf(orderId: string, invoiceNumber?: string): Promise<void> {
  const token = localStorage.getItem('auth_token');
  const resp = await fetch(`${API_BASE}/orders/${orderId}/invoice/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!resp.ok) throw new Error('Failed to generate PDF');

  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${invoiceNumber || 'Invoice'}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
